import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box, Divider } from "@mui/material";
import { AutorenewOutlined, InfoOutlined, SearchOutlined } from "@mui/icons-material";
import { animalAssets, createAssets, mainAssets } from '../../../services/constant';

import axios from 'axios';
import toast from 'react-hot-toast';
import API_BASE_URL, { Providers } from '../../../services/Config';
import DatePicker from "react-datepicker";
import { useGlobalContext } from '../../../services/GlobalContext';

// import IC_CHECK_SYMBOL from '../../../assets/img/animal/ic_modal_checkbtn.png';
const ModalView = ({ show, setShow, serviceItems, setServiceItems }) => {
    const [categoryOptions, setcategoryOptions] = useState([1]);
    const [selectedServiceOptions, setSelectedServiceOptions] = useState([1, 2]);
    const [serviceOptions, setServiceOptions] = useState([{ id: 1, name: 'TODAS' }], []);
    const [serviceNames, setServiceNames] = useState('');
    const [filterServiceOpen, setFilteroption1] = useState(false);
    const [filterCategoryOpen, setFilteroption2] = useState(false);
    const [status, setStatus] = useState(0);
    const [emptyState, setEmptyState] = useState(true);
    const [emptyCategory, setEmptyCategory] = useState(true);

    //////////////////-----------for status 1------------------//////////
    const [serviceSelected, setServiceSelected] = useState([]);
    const [itemSelected, setItemSelected] = useState([]);

    ////////////////--------------for status 2---------------///////////
    const [entitylist, setEntitylist] = useState([]);
    const [removelist, setRemovelist] = useState([]);
    const [addlist, setAddlist] = useState([]);
    const [loadingNew, setLoadingNew] = useState(false);


    const { data, setloading } = useGlobalContext();
    const [notes, setNotes] = useState('');
    const [occurrence, setOccurrence] = useState({});
    const [showError, setShowError] = useState(false);


    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElValue, setAnchorElValue] = React.useState(null);
    const [iconvalue, setIconvalue] = useState('');
    const [openPopUpId, setOpenPopUpId] = useState(null);
    const [openPopUpId1, setOpenPopUpId1] = useState(null);
    const userData = JSON.parse(localStorage.getItem('userData'));
    const provider_id = userData['provider_id'];
    const token = localStorage.getItem('authToken');
    const network_id = localStorage.getItem('network_id');
    const entity_ids = localStorage.getItem('entity_id');
    const initState = () => {
        setServiceSelected([]);
        setItemSelected([]);
        setEntitylist([]);
        setNotes('');
        setOccurrence({});
        setRemovelist([]);
        setAddlist([]);
        setShowError(false);
    }

    const modalClose = () => {
        setShow(false);
        initState();
        setStatus(0);
    }

    const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    ///////////////////////////////////////////////////////////////////////
    ///////////////////// filter section //////////////////////////////////
    ///////////////////////////////////////////////////////////////////////
    const selectCategory = (id) => {
        let updatedOptions;
        if (id === 1) {
            const ids = serviceOptions.map(items => items.id);
            // If '1' is selected or deselected, toggle its presence in the array
            updatedOptions = categoryOptions.includes(1) ? [] : ids;
        } else {
            // If any ID other than '1' is selected
            if (categoryOptions.includes(id)) {
                // If it's already selected, remove it
                updatedOptions = categoryOptions.filter((option) => option !== id && option !== 1);
            } else {
                // If it's not selected, remove '1' if it's in the array and add the new ID
                updatedOptions = [...categoryOptions.filter((option) => option !== 1), id];
            }

        }
        setcategoryOptions(updatedOptions);


        filterServiceOptions(selectedServiceOptions, updatedOptions, serviceNames);


    };
    const debouncedHandleChange = useCallback(
        _.debounce((value) => {
            filterServiceOptions(selectedServiceOptions, categoryOptions, value);
        }, 500),
        []
    );
    const selectName = (e) => {
        setServiceNames(e.target.value);
        debouncedHandleChange(e.target.value);
    }
    const selectService = (id) => {
        const options = selectedServiceOptions.includes(id) ? selectedServiceOptions.filter((option) => option !== id) : [...selectedServiceOptions, id];
        setSelectedServiceOptions((prev) =>
            prev.includes(id) ? prev.filter((option) => option !== id) : [...prev, id]
        );
        if (options.length > 0) {
            setEmptyState(false);
            setEmptyCategory(false);
        }
        filterServiceOptions(options, categoryOptions, serviceNames);
    }
    const DropdownService = () => {
        setFilteroption1(!filterServiceOpen);
    };

    const DropdownCategory = () => {
        setFilteroption2(!filterCategoryOpen);
    };

    const serviceOption = [
        { id: 1, label: 'Serviços', name: 'services' },
        { id: 2, label: 'Itens', name: 'items' },
    ]

    const fetchCategoryOptions = async () => {

        await axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}`+ '/networks/' + network_id + `/entities/${entity_ids ? entity_ids + `/` : `main/`}search-categories`, {}, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then((res) => {

            const data = [
                { id: 1, name: 'TODAS' },
                ...res.data.categories,
            ]
            setServiceOptions(data);
            setcategoryOptions(data.map(items => items.id));
        }).catch((err) => {
            toast.error(err.code);

        })
    }

    const filterServiceOptions = async (typeOptions, categoryOption, name) => {
        let filters = {};
        if (typeOptions.length > 0) {
            const names = typeOptions.map(id => {
                const matchedOption = serviceOption.find(option => option.id === id);
                return matchedOption ? matchedOption.name : null;
            });
            filters.types = names
        } else {
            setEmptyState(true);
            return;
        }
        if (categoryOption.length > 0) {
            if (categoryOption[0] !== 1) {
                filters.categories = categoryOption.map(id => ({ id }))
            }
        } else {

            setEmptyCategory(true);
            return;
        }
        if (name !== '') {
            filters.name = name
        }
        if (Object.keys(filters).length > 0) {

            await axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}` + '/networks/' + network_id + `/entities/${entity_ids ? entity_ids + `/` : `main/`}search-services-and-items`, {
                filters
            }, {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                setServiceItems(res.data);
                setEmptyState(false);
                setEmptyCategory(false);
            }).catch((err) => {
                toast.error(err.code);

            })
        } else {

            setEmptyState(true);
            fetchServiceItems();
        }
    }
    const fetchServiceItems = async () => {

        await axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}` + '/networks/' + network_id + `/entities/${entity_ids ? entity_ids + `/` : `main/`}search-services-and-items`, {}, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then((res) => {

            setServiceItems(res.data);
        }).catch((err) => {
            toast.error(err.code);

        })
    }
    useEffect(() => {
        if (show) {

            fetchCategoryOptions();
            fetchServiceItems();
        }
    }, [show])

    ///////////////////////////////////////////////////////////////////////
    /////////////////////// Body section //////////////////////////////////
    ///////////////////////////////////////////////////////////////////////


    ///////////---------for note -------------/////////////////////////////
    const open = Boolean(anchorEl);

    const handlPopUp = (event, item) => {
        setAnchorEl(event.currentTarget);
        setNotes(item.notes);
        setOpenPopUpId(item.id);
    };
    const handlePopUpClose = (item) => {
        setAnchorEl(null);
        if (notes !== '') {
            entitylist.sort((a, b) => {
                if (a.entity_description < b.entity_description) {
                    return -1;
                }
                if (a.entity_description > b.entity_description) {
                    return 1;
                }
                return 0; // If they are equal
            });
            const updatedEntity = entitylist.map((items) => {
                if (items === item) {
                    items.notes = notes;
                }
                return items;
            });
            setNotes('');
            setEntitylist(updatedEntity);
            setOpenPopUpId(null);

        }
    };

    const handleTextArea = (e, item) => {
        setNotes(e.target.value);
    }

    const updatePVP = (e, item) => {
        if (e.target.value < 0)
            return;
        entitylist.sort((a, b) => {
            if (a.entity_description < b.entity_description) {
                return -1;
            }
            if (a.entity_description > b.entity_description) {
                return 1;
            }
            return 0; // If they are equal
        });
        setStatus(3);
        setEntitylist(prevEntries =>
            prevEntries.map(entry =>
                entry === item ? { ...entry, list_price_amount_at_consumption: e.target.value } : entry
            )
        );

    }

    //////////-----------for QT --------------////////////////////////////
    const updateQt = (e, item) => {
        if (e.target.value < 0)
            return;
        entitylist.sort((a, b) => {
            if (a.entity_description < b.entity_description) {
                return -1;
            }
            if (a.entity_description > b.entity_description) {
                return 1;
            }
            return 0; // If they are equal
        });
        setEntitylist(prevEntries =>
            prevEntries.map(entry =>
                entry === item ? { ...entry, quantity: e.target.value } : entry
            )
        );

    }
    const updateDate = (e, item) => {
        const date = new Date(e);
        entitylist.sort((a, b) => {
            if (a.entity_description < b.entity_description) {
                return -1;
            }
            if (a.entity_description > b.entity_description) {
                return 1;
            }
            return 0; // If they are equal
        });
        const _formatDate = formatDate(date);
        if (date) {
            setEntitylist(prevEntries =>
                prevEntries.map(entry =>
                    entry === item ? { ...entry, consumption_date: _formatDate } : entry
                )
            );
        }
    }

    /////////-----------for Convencionado ----////////////////////////////
    const openValue = Boolean(anchorElValue);
    const idValue = openValue ? 'simple-popover' : undefined;

    const handlPopUpValue = (e, value, id) => {
        setAnchorElValue(e.currentTarget);
        setIconvalue(value);
        setOpenPopUpId1(id);
    };
    const handlePopUpCloseValue = () => {
        setAnchorElValue(null);
        setIconvalue('');
        setOpenPopUpId1(null);
    };

    const handleRemoveService = (item) => {
        const updatedItems = serviceSelected.filter(items => items !== item);
        setServiceSelected(updatedItems);
    }
    const handleRemoveItem = (item) => {
        const updatedItems = itemSelected.filter(items => items !== item);
        setItemSelected(updatedItems);
    }
    const handleAdd = async (e) => {
        const policy_id = data?.policies[0]?.id;
        const quote_id = data?.policies[0]?.quote_id;
        const insuree_id = data?.insuree?.id;

        const consumption = [];
        if (serviceSelected.length > 0) {
            serviceSelected.forEach((item) => {
                const _quantity = entitylist.filter((items) => items.entity_description === getServiceName(item, ''))
                if (_quantity.length > 0) {
                    consumption.push({
                        entity: "networkdirectoryentityofferedservices",
                        entity_id: item.split(':')[1],
                        quantity: _quantity[0].quantity,
                        list_price_amount_at_consumption: _quantity[0].list_price_amount_at_consumption,
                        consumption_date: _quantity[0].consumption_date,
                        notes: _quantity[0].notes,
                    });
                }
                else
                    consumption.push({
                        entity: "networkdirectoryentityofferedservices",
                        entity_id: item.split(':')[1],
                    });
            })
        }

        if (itemSelected.length > 0) {
            itemSelected.forEach((item) => {
                const _quantity = entitylist.filter((items) => items.entity_description === getServiceName('', item))
                if (_quantity.length > 0) {
                    consumption.push({
                        entity: "networkdirectoryentityoffereditems",
                        entity_id: item.split(':')[1],
                        quantity: _quantity[0].quantity,
                        list_price_amount_at_consumption: _quantity[0].list_price_amount_at_consumption,
                        consumption_date: _quantity[0].consumption_date,
                        notes: _quantity[0].notes,
                    });
                }
                else
                    consumption.push({
                        entity: "networkdirectoryentityoffereditems",
                        entity_id: item.split(':')[1],
                    });
            });
        }

        const _occurrence = occurrence === "" ? {
            "occurrencespec_id": "03309e1a-446e-44ef-8e5d-1fb98ef97f51",
            "description": "Jackie Cat: 202409121"
        } : {
            "id": occurrence.id,
            "occurrencespec_id": "03309e1a-446e-44ef-8e5d-1fb98ef97f51",
            "description": "Jackie Cat: 202409121"
        }
        let param;
        if (entity_ids) {
            param = {
                policy_id, quote_id, insuree_id,
                entity_id: entity_ids,
                consumption_entries: consumption,
                occurrence: _occurrence,
            }
        } else {
            param = {
                policy_id, quote_id, insuree_id,
                consumption_entries: consumption,
                occurrence: _occurrence,
            }
        }
        setLoadingNew(true);
        setStatus(2);
        await axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}` + '/networks/' + network_id + '/validate-eligibility',
            param, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then((res) => {
            setLoadingNew(false);
            const valid = res.data?.consumption_entries?.some(item => item.required_list_price === true);
            if (!valid)
                setStatus(4);
            const sortedData = res.data.consumption_entries.sort((a, b) => {
                if (a.entity_description < b.entity_description) {
                    return -1;
                }
                if (a.entity_description > b.entity_description) {
                    return 1;
                }
                return 0; // If they are equal
            });
            setEntitylist(sortedData);
            setOccurrence(res.data.occurrence);
        }).catch((err) => {
            console.log(err)
            setLoadingNew(false);
            toast.error(err.code);
        })

    }
    const handleRegist = async (e) => {

        const _consumption = [];

        if (serviceSelected.length > 0) {
            serviceSelected.forEach((item) => {
                _consumption.push({
                    entity: "networkdirectoryentityofferedservices",
                    entity_id: item.split(':')[1],
                });
            })
        }

        if (itemSelected.length > 0) {
            itemSelected.forEach((item) => {
                _consumption.push({
                    entity: "networkdirectoryentityoffereditems",
                    entity_id: item.split(':')[1],
                });
            });
        }


        const consumption = [];
        let index = 0;
        for (let data of entitylist) {
            let _data;
            if (addlist.includes(_consumption[index].entity_id)) {
                _data = {
                    id: data.id,
                    quantity: data.quantity,
                    list_price_amount_at_consumption: data.list_price_amount_at_consumption,
                    notes: data.notes,
                    consumption_date: data.consumption_date,
                };
            } else {
                _data = {
                    id: data.id,
                    quantity: data.quantity,
                    list_price_amount_at_consumption: data.list_price_amount_at_consumption,
                    notes: data.notes,
                };
            }


            consumption.push(_data);

            index++;
        }
        if (removelist.length > 0) {
            removelist.map(data => {
                const _data = {
                    id: data,
                    deleted: true,
                }
                consumption.push(_data);
            })
        }
        let param;
        if (entity_ids) {
            param = {
                entity_id: entity_ids,
                consumption_entries: consumption,
                occurrence_date: occurrence.occurrence_date,
            }
        } else {
            param = {
                consumption_entries: consumption,
                occurrence_date: occurrence.occurrence_date,
            }
        }

        await axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}/networks/${network_id}/occurrences/${occurrence.id}/update-consumptions`, param, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then(async (res) => {

            const valid = res.data.consumptions_entries.filter((items) => items.state !== 'validated');
            if (valid.length === 0) {

                await axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}/networks/${network_id}/occurrences/${occurrence.id}/validate-and-submit-consumptions`, {}, {
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json',
                    }
                }).then((res) => {

                    toast.success('Criado com sucesso.');
                    initState();
                    setStatus(0);
                    setShow(false);
                }).catch((err) => {
                    toast.error(err.response.data.error);

                })

            } else {
                // toast.success('Enviado com sucesso.');
                // initState();
                // setStatus(0);
                // setShow(false);
                setEntitylist(res.data.consumptions_entries);
                const valid1 = res.data.consumptions_entries.filter((items) => items.state === 'rejected');
                if (valid1.length === 0) {
                    toast.error("Existem elementos inválidos");
                } else {
                    setShowError(true);
                }
            }

        }).catch((err) => {
            toast.error(err.response.data.error);

        })

    }

    const handleService = (categoryId, serviceId) => {
        if (status === 3) {
            toast.error("Precisamos de recalcular antes disso.");
            return;
        }
        setLoadingNew(true);
        const itemKey = `${categoryId}:${serviceId}`;

        const serviceName = getServiceName(itemKey, '');
        const entry = entitylist.find(entry => entry.entity_description === serviceName);
        if (entry)
            serviceSelected.includes(itemKey) ? setRemovelist([...removelist, entry.id]) : setAddlist([...addlist, serviceId]);

        setLoadingNew(false);
        setServiceSelected(prevState =>
            prevState.includes(itemKey)
                ? prevState.filter(i => i !== itemKey)
                : [...prevState, itemKey]
        );
    }

    const handleItems = (categoryId, itemId) => {
        if (status === 3) {
            toast.error("Precisamos de recalcular antes disso.");
            return;
        }
        setLoadingNew(true);
        const itemKey = `${categoryId}:${itemId}`;

        const serviceName = getServiceName('', itemKey);
        const entry = entitylist.find(entry => entry.entity_description === serviceName);
        if (entry)
            itemSelected.includes(itemKey) ? setRemovelist([...removelist, entry.id]) : setAddlist([...addlist, itemId]);

        setLoadingNew(false);
        setItemSelected(prevState =>
            prevState.includes(itemKey)
                ? prevState.filter(i => i !== itemKey)
                : [...prevState, itemKey]
        );

    }
    const getServiceName = (serviceKey, itemKey) => {
        if (serviceKey.length > 0) {
            const [categoryId, serviceId] = serviceKey.split(':').map(String);
            const serviceItem = serviceItems.services.find(s => s.service_id === serviceId && s.category_id === categoryId);
            if (!serviceItem) return '';

            return serviceItem.service_name;
        } else {
            const [categoryId, itemId] = itemKey.split(':');
            const serviceItem = serviceItems.items.find(s => s.item_id === itemId && s.category_id === categoryId);
            if (!serviceItem) return '';
            return serviceItem.item_name;
        }
    };
    const getItemsName = (itemKey) => {

        const [categoryId, itemId] = itemKey.split(':');
        const serviceItem = serviceItems.items.find(s => s.item_id === itemId && s.category_id === categoryId);
        if (!serviceItem) return '';
        return serviceItem.item_name;

    };
    const handleRemoveItems = (item) => {
        entitylist.sort((a, b) => {
            if (a.entity_description < b.entity_description) {
                return -1;
            }
            if (a.entity_description > b.entity_description) {
                return 1;
            }
            return 0; // If they are equal
        });
        const updatedItems = entitylist.filter(items => items !== item);
        setEntitylist(updatedItems);

        const updatedService = serviceSelected.filter(items => getServiceName(items) !== item.entity_description);
        setServiceSelected(updatedService);

        console.log(itemSelected)
        const updateItems = itemSelected.filter(items => getItemsName(items) !== item.entity_description);
        setItemSelected(updateItems);

        setRemovelist([...removelist, item.id]);
    }

    useEffect(() => {
        if (serviceSelected.length > 0 || itemSelected.length > 0) {
            // setEntitylist([]);
            if (status === 3)
                return;
            handleAdd();
            setShowError(false);
        } else {
            setStatus(0);
            setAddlist([]);
            setRemovelist([]);
        }
    }, [serviceSelected, itemSelected])


    return (
        <Modal
            show={show}
            onHide={() => modalClose()}
            dialogClassName="modal_view modal-100w"
            aria-labelledby="example-custom-modal-styling-title"
            style={{ maxWidth: '100%' }}
            className="max-height"
        >
            <Modal.Header closeButton className="modal_header">
                <div className="font-center w-100 font-24-600 ">
                    <span className="center header_title font-color" >Registo de Consumos</span>

                </div>
                {
                    (status === 4) ? (<><button className="font-14-500 header_btn_regist mr-[2rem] z-[10000] hover:bg-[#29215B] hover:border-[#29215b]" onClick={(e) => handleRegist(e)}>REGISTAR</button></>) : status === 3 ? (<button className="font-14-500 w-[13rem] h-[3.5rem] text-white rounded-[2rem] mr-[2rem] bg-[#29215B] z-[10000] hover:bg-[#f9bc04]" onClick={() => handleAdd()}>Recalcular <AutorenewOutlined className="w-[19px] h-[19px] text-white" /></button>) : (<><button className="font-14-500 w-[10rem] h-[3.5rem] text-white rounded-[2rem] mr-[2rem] bg-[#B2C3D4] ">REGISTAR</button></>)
                }
            </Modal.Header>
            <Modal.Body>
                <div className="modal_body w-100" style={{ height: 'calc(100vh - 13rem)' }}>
                    <div className="body_filter">
                        <span className="font-16-900 font-left font-color1 mb-[2rem]"> FILTROS</span>

                        <div className="mb-[2rem]">
                            <button onClick={DropdownService} className={!filterServiceOpen ? "filter_select font-16-600 font-color" : "filter_select_click font-16-600"}>
                                <span className="font-color">Serviços, Itens</span> <img src={animalAssets.ic_arrow_down} alt="" className="arrow_btn top-[1rem]" />
                            </button>
                            {filterServiceOpen && (
                                <div className="custom-select-dropdown font-15-400">
                                    {serviceOption.map((option) => (
                                        <label key={option.id} className="custom-select-option">
                                            <input
                                                type="checkbox"
                                                checked={selectedServiceOptions.includes(option.id)}
                                                onChange={() => selectService(option.id)}
                                                className="custom-checkbox-input"
                                            />
                                            <span className="custom-checkbox"></span>
                                            <span className="font-left">{option.label}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div>
                            <div className="custom-select-container mb-[2rem]">
                                <button onClick={DropdownCategory} className={!filterCategoryOpen ? "filter_select font-16-600 font-color" : "filter_select_click font-16-600"}>
                                    <span className="font-color"> Todas as categorias </span> <img src={animalAssets.ic_arrow_down} alt="" className="arrow_btn top-[1rem]" />
                                </button>

                                {filterCategoryOpen && (
                                    <div className="custom-select-dropdown font-15-400">
                                        {serviceOptions.map((option) => (
                                            <label key={option.id} className="custom-select-option">
                                                <input
                                                    type="checkbox"
                                                    checked={categoryOptions.includes(option.id)}
                                                    onChange={() => selectCategory(option.id)}
                                                    className="custom-checkbox-input"
                                                />
                                                <span className="custom-checkbox"></span>
                                                <span className="font-left">{option.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="mb-[2rem] relative">
                                <input className={serviceNames ? "filter_select font-15-400 font-color font-left search_bar" : "filter_select font-15-600 font-color1 font-left search_bar"} placeholder={`Ex: consultas, exames  `} onChange={(e) => selectName(e)} value={serviceNames}>
                                </input>
                                <SearchOutlined className="searchIcon" />
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-row w-full">
                        <div className="w-[35%] body_content border-r-[1px] border-r-[#BDCDDD]">
                            {
                                <>
                                    <section className="flex-column mb-1">
                                        <div className="flex-row mb-[2rem]">
                                            <img src={animalAssets.ic_service} className="mr-[1rem]" alt="" />
                                            <span className="font-16-400 font-color font-italic">Serviços</span>
                                        </div>
                                        {
                                            serviceOptions.length > 0 && serviceItems.services ?
                                                serviceItems.services.length > 0 ?
                                                    serviceOptions.map((category) =>
                                                        category.id === 1 ? (<></>) :
                                                            (
                                                                <section className="mb-1" key={category.id}>
                                                                    <div className="mb-1">
                                                                        <span className="font-18-700 font-color">{category.name}</span>
                                                                        {serviceItems.services.map(item =>
                                                                            (item.category_id === category.id) ?
                                                                                (
                                                                                    <label className="custom-select-option font-16-400" key={item.service_id}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="custom-checkbox-input"
                                                                                            checked={serviceSelected.includes(`${category.id}:${item.service_id}`)}
                                                                                            onChange={() => handleService(category.id, item.service_id)}
                                                                                        />
                                                                                        <span className="custom-checkbox"></span>
                                                                                        {item.service_name}
                                                                                    </label>
                                                                                ) : (<></>)
                                                                        )}
                                                                    </div>
                                                                </section>
                                                            )

                                                    ) : (<></>)
                                                : (<></>)
                                        }
                                    </section>
                                    <section className="flex-column mb-1">
                                        <div className="flex-row mb-[2rem]">
                                            <img src={animalAssets.ic_inject} className="mr-[1rem]" alt=""></img>
                                            <span className="font-16-400 font-color font-italic">Itens</span>
                                        </div>
                                        {
                                            serviceOptions.length > 0 && serviceItems.items ?
                                                serviceItems.items.length > 0 ?
                                                    serviceOptions.map((category) =>
                                                        category.id === 1 ? (<></>) :
                                                            (
                                                                <section className="mb-1" key={category.id}>
                                                                    <div className="mb-1">
                                                                        <span className="font-18-700 font-color">{category.name}</span>
                                                                        {serviceItems.items.map(item =>
                                                                            (item.category_id === category.id) ?
                                                                                (
                                                                                    <label className="custom-select-option font-16-400" key={item.item_id}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="custom-checkbox-input"
                                                                                            checked={itemSelected.includes(`${category.id}:${item.item_id}`)}
                                                                                            onChange={() => handleItems(category.id, item.item_id)}
                                                                                        />
                                                                                        <span className="custom-checkbox"></span>
                                                                                        {item.item_name}
                                                                                    </label>
                                                                                ) : (<></>)
                                                                        )}
                                                                    </div>
                                                                </section>
                                                            )

                                                    ) : (<></>)
                                                : (<></>)
                                        }
                                    </section>
                                </>
                            }
                        </div>
                        <div className="w-[66%] flex flex-col max-h-[82vh] h-full overflow-y-scroll">
                            {
                                serviceSelected.length < 1 && itemSelected.length < 1 ?
                                    <div className="flex-column mt-auto mb-auto"> <img src={mainAssets.warn} alt="" className="font-center mt-5" /> <span className="font-18-700 font-color1 mt-5 font-center">A  lista de consumos selecionados <br></br>
                                        aparecerá aqui assim que fizer a sua escolha.</span></div>
                                    :
                                    // (<div className="content_header">
                                    //     {serviceSelected.map((item, index) => (
                                    //         <section >
                                    //             <div className="header_notification btn-common" onClick={() => handleRemoveService(item)}>
                                    //                 <div className="font-16-500 font-color">

                                    //                     <span key={item} style={{ marginRight: index < serviceSelected.length - 1 ? '2.5rem' : '0' }}>
                                    //                         {getServiceName(item, [])}
                                    //                     </span>
                                    //                 </div>
                                    //                 <button className="custom-button font-13-500" style={{ backgroundColor: 'rgba(254, 243, 209, 1)' }}><img src={animalAssets.ic_close} alt="" /></button>
                                    //             </div>
                                    //         </section>
                                    //     ))}

                                    //     {itemSelected.map((item, index) => (
                                    //         <section >
                                    //             <div className="header_notification btn-common" onClick={() => handleRemoveItem(item)}>
                                    //                 <div className="font-16-500 font-color">
                                    //                     <span key={item} style={{ marginLeft: '2.5rem' }}>
                                    //                         {getServiceName([], item)}
                                    //                     </span>
                                    //                 </div>
                                    //                 <button className="custom-button font-13-500" style={{ backgroundColor: 'rgba(254, 243, 209, 1)' }}><img src={animalAssets.ic_close} alt="" /></button>
                                    //             </div>
                                    //         </section>
                                    //     ))}
                                    // </div>
                                    // )

                                    (
                                        <>
                                            <section className="content_header ">
                                                {
                                                    entitylist.length > 0 ? (
                                                        entitylist.map((item) =>
                                                        (
                                                            <div>
                                                                <div className="flex flex-col border-[#BDCDDD] p-[1.7rem] rounded-[1rem] border-[1px] mt-[2.7rem]" style={{
                                                                    boxShadow: '0px 3px 3px 0px #0000001A'
                                                                }}>
                                                                    <div className="flex flex-row justify-between border-b-[#BDCDDD] border-b-[1px] pb-[16px]">
                                                                        <span className="font-16-500 font-center font-color px-[16px]">{item.entity_description}</span>
                                                                        <div className="flex flex-row gap-[5px]">
                                                                            <span className="font-13-400 font-center mr-[1rem] font-grey">Data:</span>
                                                                            <DatePicker className="font-13-500 font-center mr-[1rem] input_special input_date" selected={item.consumption_date} onChange={(e) => updateDate(e, item)} dateFormat="dd/MM/yyyy"></DatePicker>

                                                                            <span className="font-13-400 font-center mr-[1rem] font-grey">Qt:</span>
                                                                            <input className="input_qt font-13-500 font-center mr-[2rem] input_special" type="number" onChange={(e) => updateQt(e, item)} value={item.quantity} />
                                                                            <button className="custom-button " onClick={() => handleRemoveItems(item)}><img src={animalAssets.ic_close} alt="" /></button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex flex-row gap-4 pt-[16px] justify-between">
                                                                        <div className="flex flex-row place-self-center w-full">
                                                                            <div className="flex flex-row gap-4 px-[16px] border-r-[#BDCDDD] border-r-[1px]">
                                                                                <span className="ml-[1rem] font-13-400 font-center font-grey">PVP:</span>
                                                                                {
                                                                                    item.required_list_price !== true ?
                                                                                        (<input className="input_qt font-15-700 font-center mr-[1rem] input_special" type="number" step="0.01" onChange={(e) => updatePVP(e, item)} value={item.list_price_amount_at_consumption === null ? 0 : item.list_price_amount_at_consumption} />
                                                                                        ) :
                                                                                        (<input className="input_qt font-15-700 font-center mr-[1rem] modal_special" type="number" step="0.01" onChange={(e) => updatePVP(e, item)} value={item.list_price_amount_at_consumption === null ? 0 : item.list_price_amount_at_consumption} />
                                                                                        )
                                                                                }
                                                                            </div>
                                                                            <div className="flex flex-row gap-4 px-[16px] border-r-[#BDCDDD] border-r-[1px]">
                                                                                <span className="font-13-400 font-center font-grey"> A Cargo do Cliente:</span>
                                                                                <span className="font-15-700 font-center mr-[1rem] ">{item.copayment_amount_at_consumption === null ? 0 : item.copayment_amount_at_consumption}&euro;</span>
                                                                            </div>
                                                                            <div className="flex flex-row gap-4 px-[16px] border-r-[#BDCDDD] border-r-[1px]">
                                                                                <span className="font-13-400 font-center font-grey"> A Cargo da Seguradora:</span>

                                                                                <button className="custom-button mr-[1rem]" onClick={(e) => handlPopUpValue(e, item.entity_id, item.id)}><img src={iconvalue === item.entity_id ? animalAssets.ic_eye : animalAssets.ic_eye_active} alt="" /></button>
                                                                            </div>

                                                                            <Popover
                                                                                id={item.id}
                                                                                open={openPopUpId1 === item.id}
                                                                                anchorEl={anchorElValue}
                                                                                onClose={handlePopUpCloseValue}
                                                                                anchorOrigin={{
                                                                                    vertical: 'bottom',
                                                                                    horizontal: 'right',
                                                                                }}
                                                                                transformOrigin={{
                                                                                    vertical: 'top',
                                                                                    horizontal: 'right',
                                                                                }}
                                                                                sx={{
                                                                                    marginTop: '0.5rem',
                                                                                    '& .MuiPaper-root': {
                                                                                        border: '1px solid #fff',
                                                                                        borderRadius: '1.1rem',
                                                                                        minWidth: '26.7rem',
                                                                                        boxShadow: '0px 0px 23px 0px rgba(0, 0, 0, 0.15)',
                                                                                    },
                                                                                }}
                                                                            >
                                                                                <Typography className="flex-column" style={{ padding: '2rem', width: '100%' }}>
                                                                                    <div className="flex-row font-left" >
                                                                                        <span className="font-13-700 font-color">Valor Convencionado Medipet:  </span>
                                                                                        <span className="font-grey font-13-700" style={{ position: 'absolute', right: '30px' }}>{item.agreed_amount_at_consumption ? item.agreed_amount_at_consumption : 0} </span>
                                                                                    </div>
                                                                                    <div className="flex-row font-left" >
                                                                                        <span className="font-13-700 font-color">A Cargo do cliente:  </span>
                                                                                        <span className="font-grey font-13-700" style={{ position: 'absolute', right: '30px' }}>{item.copayment_amount_at_consumption ? item.copayment_amount_at_consumption : 0} </span>
                                                                                    </div>
                                                                                    <div className="flex-row font-left" >
                                                                                        <span className="font-13-700 font-color">A Cargo da Seguradora:  </span>
                                                                                        <span className="font-grey font-13-700" style={{ position: 'absolute', right: '30px' }}>{item.coinsurance_amount_at_consumption ? item.coinsurance_amount_at_consumption : 0} </span>
                                                                                    </div>
                                                                                </Typography>
                                                                            </Popover>

                                                                        </div>
                                                                        <button className="custom-button mr-[1rem]" onClick={(e) => handlPopUp(e, item)}><img src={animalAssets.ic_editable} alt="" /></button>
                                                                        <Popover
                                                                            id={item.id}
                                                                            open={openPopUpId === item.id}
                                                                            anchorEl={anchorEl}
                                                                            onClose={handlePopUpClose}
                                                                            anchorOrigin={{
                                                                                vertical: 'bottom',
                                                                                horizontal: 'right',
                                                                            }}
                                                                            transformOrigin={{
                                                                                vertical: 'top',
                                                                                horizontal: 'right',
                                                                            }}
                                                                            disableAutoFocus={true}
                                                                            disableEnforceFocus={true}
                                                                            disablePortal={true}
                                                                            sx={{
                                                                                marginTop: '2.5rem',
                                                                                '& .MuiPaper-root': {
                                                                                    border: '1px solid #fff',
                                                                                    borderRadius: '1.1rem',
                                                                                    minWidth: '40rem',
                                                                                    boxShadow: '0px 0px 23px 0px rgba(0, 0, 0, 0.15)',
                                                                                },
                                                                            }}
                                                                        >
                                                                            <Box className="flex-column" style={{ padding: '1rem', height: '18.8rem' }}>
                                                                                <div className="flex-row mb-[2rem]" style={{ justifyContent: 'space-between' }}>
                                                                                    <div className="font-14-500 font-color1">Notas adicionais</div>
                                                                                    <button className="custom-button " onClick={() => handlePopUpClose(item)}><img src={notes ? animalAssets.ic_modal_ok : animalAssets.ic_modal_disable} alt=""></img></button>
                                                                                </div>
                                                                                <textarea className="popup_tag popup_textarea  font-14-400 font-left" type="text" value={notes} placeholder="Inserir..." onChange={(e) => handleTextArea(e, item)} />
                                                                            </Box>
                                                                        </Popover>
                                                                    </div>
                                                                    <div className="flex flex-row">
                                                                        {item.required_list_price === true ?
                                                                            (<div className="bg-[#FBBD18] fl ex flex-row rounded-[5px] w-full p-[4px] gap-[8px] mt-[8px] place-content-center">
                                                                                <InfoOutlined style={{ color: 'white', alignSelf: 'center' }} />
                                                                                <span className="font-13-400 text-white">Insira o PVP para obter o  <span className="font-extrabold text-[15px] ">calculo </span> dos valores e continuar!</span>
                                                                            </div>) : (<></>)
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )))
                                                        : (<></>)
                                                }
                                                {
                                                    loadingNew ? (
                                                        <div className="header_notification btn-common " style={{ background: 'none', border: 'none' }}>
                                                            <div className="font-16-500 flex flex-row">
                                                                <img src={mainAssets.MediPet_loading} alt="gif" style={{ height: '24px', marginRight: '16px' }} />
                                                                <span style={{ marginRight: '0px', color: 'rgba(249, 188, 4, 1)' }}>
                                                                    A validar elegibilidade...
                                                                </span>
                                                            </div>
                                                        </div>) : (<></>)
                                                }

                                            </section>
                                        </>
                                    )
                            }
                        </div>
                    </div>

                </div>
            </Modal.Body>
        </Modal >
    );
}
export default ModalView;